<app-section-header-gap></app-section-header-gap>
<app-section-details
  [book]="(book | async)"
></app-section-details>
